import { AppError } from '../api';

export enum AppErrorKeys {
  // From Front
  NoRefreshToken = 'NoRefreshToken',
  LoadUserFailedAfterRegister = 'LoadUserFailedAfterRegister',
  NoActivityFoundForFileOpen = 'NoActivityFoundForFileOpen',
  CouldNotGenerateIcsFile = 'CouldNotGenerateIcsFile',
  CouldNotFindRestaurant = 'CouldNotFindRestaurant',
  ScanPermissionNotGranted = 'ScanPermissionNotGranted',
  ScanNotSupported = 'ScanNotSupported',
  ScanNoQrCodeFound = 'ScanNoQrCodeFound',
  ScanInvalidData = 'ScanInvalidData',
  ScanCancelled = 'ScanCancelled',
  NoScorpOrderToday = 'NoScorpOrderToday',
  // From API
  AnErrorOccured = 'AnErrorOccured',
  DeactivatedPayment = 'DeactivatedPayment',
  CaisseUnavailable = 'CaisseUnavailable',
  InvalidEmailOrPassword = 'InvalidEmailOrPassword',
  EmailAlreadyUsed = 'EmailAlreadyUsed',
  EmailDoesNotMatchDomainPolicy = 'EmailDoesNotMatchDomainPolicy',
  EmailRequireSamlSingleSignOn = 'EmailRequireSamlSingleSignOn',
  SiteNotFound = 'SiteNotFound',
  CompteClientNotFound = 'CompteClientNotFound',
  CompteClientLocked = 'CompteClientLocked',
  CompteClientPendingClosure = 'CompteClientPendingClosure',
  CompteClientExpired = 'CompteClientExpired',
  NoConviveFound = 'NoConviveFound',
  UserLockedOut = 'UserLockedOut',
  InvalidPassword = 'InvalidPassword',
  BadgeNumberRequired = 'BadgeNumberRequired',
  BadgeBalanceRequired = 'BadgeBalanceRequired',
  ContractTypeRequired = 'ContractTypeRequired',
  ConfirmedEmailRequired = 'ConfirmedEmailRequired',
  NoNetwork = 'NoNetwork',
  NumeroTableInvalid = 'NumeroTableInvalid',
  OutOfStock = 'OutOfStock',
}

export const isAppError = (err: any): err is AppError => {
  return (err as AppError).errorKey !== undefined;
};

export const appErrorFromError = (err: any): AppError => {
  return { errorKey: AppErrorKeys.AnErrorOccured, message: err?.message || 'Error occured', httpStatusCode: 0, payload: err };
};

export const appErrorFromKey = (errorKey: AppErrorKeys | string): AppError => {
  return { errorKey: errorKey, message: `Error occured : ${errorKey}`, httpStatusCode: 0, payload: errorKey };
};

export const ensureAppError = (err: any | AppError | null): AppError => {
  if (!err) {
    return appErrorFromKey(AppErrorKeys.AnErrorOccured);
  }

  if (isAppError(err)) return err;

  return appErrorFromError(err);
};
